<script>import { onDestroy } from 'svelte';
import { getTypedContext } from './Canvas.svelte';
const { register, unregister, redraw } = getTypedContext();
export let setup = undefined;
export let render = () => undefined;
const layerId = register({ setup, render });
onDestroy(() => unregister(layerId));
$: render, redraw();
</script>

<div data-layer-id={layerId} />
